import { ICessionAction, ICessionState } from './cession.interfaces';
import { cessionActionType } from './cessionActionType';

export const cessionInitialState: ICessionState = {
  hasCessionConfiguration: false,
};

export const cessionReducer = (
  state: ICessionState = cessionInitialState,
  action: ICessionAction,
): ICessionState => {
  switch (action.type) {
    case cessionActionType.SET_HAS_CESSION_CONFIGURATION:
      return {
        ...state,
        hasCessionConfiguration: action.payload.hasCessionConfiguration,
      };

    default:
      return state;
  }
};
